import { RespInterface, RespListInterface } from "@common/ports/interfaces";
import { Observable } from "rxjs";
import { PaymentSuppliersInterface, SuppliersInterface } from "../interfaces";

export abstract class SuppliersAbstraction {
    /** Supplier */
    abstract list(query: string): Observable<RespListInterface<SuppliersInterface>>;
    abstract create(supplier: SuppliersInterface): Observable<RespInterface<string>>;
    abstract update(supplier: SuppliersInterface): Observable<RespInterface<string>>;
    abstract read(id: string): Observable<RespInterface<SuppliersInterface>>;
    abstract delete(id: string): Observable<RespInterface<SuppliersInterface>>;

    /** Payment Supplier */
    abstract listPaymentSupplier(query: string): Observable<RespListInterface<PaymentSuppliersInterface>>;
    abstract createPaymentSupplier(paymentSupplier: PaymentSuppliersInterface): Observable<RespInterface<string>>;
    abstract updatePaymentSupplier(paymentSupplier: PaymentSuppliersInterface): Observable<RespInterface<string>>;
    abstract updatePaymentSupplierMasive(payload: { ids: string[] }): Observable<RespInterface<string>>;
}